import { useCustomT } from '@crimeos-frontend/shared/common'

import { handleAPIError } from '../../../utils/APIUtils'

import { FileUploaderFieldSignedUploadUrlQuery as Query } from './query.generatedTypes'

interface UseAPIResponseHandlerReturnType {
  handleAPIResponse: (
    response: Query,
    onSuccess: (signedUploadUrl: string) => void,
    onFailure?: (message: string) => void
  ) => void
}

const useAPIResponseHandler = (): UseAPIResponseHandlerReturnType => {
  const commonErrorT = useCustomT('common:errorMessages')
  const recordsCommonAPIErrorT = useCustomT('recordsCommon:apiErrorMessages')

  const handleAPIResponse = (
    queryResult: Query,
    onSuccess: (signedUploadUrl: string) => void,
    onFailure?: (message: string) => void
  ): void => {
    const hasEmptyResponse =
      !queryResult || !queryResult.getFileUploaderFieldSignedUploadUrl

    if (hasEmptyResponse)
      throw new Error('FileUploaderFieldSignedUploadUrl not found')

    const response = queryResult.getFileUploaderFieldSignedUploadUrl

    switch (response.__typename) {
      case 'FileUploaderFieldSignedUploadUrl': {
        onSuccess(response.signedUploadUrl)
        break
      }

      case 'RecordNotFound':
      case 'RecordAccessDenied': {
        const errorMessage =
          response.message || recordsCommonAPIErrorT(response.__typename)

        handleAPIError(errorMessage, onFailure)
        break
      }
      case 'FieldIsDeleted':
      case 'FieldNotFound': {
        const errorMessage =
          response.message || commonErrorT('configurationIsUpdated')

        handleAPIError(errorMessage, onFailure)
        break
      }
      case 'NotFileUploaderField': {
        const errorMessage =
          response.message || recordsCommonAPIErrorT('notFileUploaderField')

        handleAPIError(errorMessage, onFailure)
        break
      }
      case 'NotAllowedFileFormat': {
        const errorMessage =
          response.message || recordsCommonAPIErrorT('notAllowedFileFormat')

        handleAPIError(errorMessage, onFailure)
        break
      }

      default:
        throw new Error(
          `__typename: Invalid GetFileUploaderFieldSignedUploadUrl Response type`
        )
    }
  }

  return { handleAPIResponse }
}

export default useAPIResponseHandler
